/** Date only — the key lists live in narrow columns, and the full timestamp is
 *  one hover away rather than three wrapped lines wide. */
export const formatDate = (value?: string | null) =>
    value
        ? new Date(value).toLocaleDateString(undefined, {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
          })
        : 'never';

export const fullDate = (value?: string | null) =>
    value ? new Date(value).toLocaleString() : 'Never used';
